import {Injectable} from '@angular/core';
import {BaseurlService} from './baseurl.service';
import { HttpClient } from '@angular/common/http';
import {Observable, Subject} from 'rxjs';
import {JwtHelperService} from '@auth0/angular-jwt';

@Injectable({
  providedIn: 'root'
})
export class AuthService {


  private jwtHelper: JwtHelperService = new JwtHelperService();
  private lastTokenRefresh = 0;

  private token = 'token';

  constructor(
    public http: HttpClient,
    public baseUrlService: BaseurlService
  ) {
  }

  getToken(): string | null {
    const token = localStorage.getItem(this.token);
    const valid = !this.jwtHelper.isTokenExpired(token);

    if (token && valid) {
      const tokenExpirationDate: Date | null = this.jwtHelper.getTokenExpirationDate(token);
      if (!tokenExpirationDate) {
        return null;
      }
      const diff: number = tokenExpirationDate.getTime() - Date.now(); // remaining ms
      const diffToLastTokenRefresh: number = Date.now() - this.lastTokenRefresh;

      if (diff < 1000 * 3600 * 24 * 9 && diffToLastTokenRefresh > 1000) {
        // less than 24 hours, refresh
        this.lastTokenRefresh = Date.now();
        this.http.get<JwtModel>(this.baseUrlService.getBaseUrl() + '/jwt').subscribe(res => {
          localStorage.setItem(this.token, res.jwt);
        });
      }
    }

    if (!valid) {
      return null;
    }
    return token;
  }


  isLoggedIn(): boolean {
    const token = localStorage.getItem(this.token);
    return !!token && !this.jwtHelper.isTokenExpired(token);
  }

  roles(): string[] {
    const token = this.getToken();
    if (!token) {
      return [];
    }
    return this.jwtHelper.decodeToken(token)
      .roles
      .split(',')
      .map((it: string) => it.trim())
      .filter((it: string) => it);
  }

  hasRole(role: string): boolean {

    return this.roles().includes(role);
  }

  login(user: string, pw: string): Observable<boolean> {

    const subject = new Subject<boolean>();

    this.http.post<JwtModel>(this.baseUrlService.getBaseUrl() + '/login', {username: user, password: pw}).subscribe({
      next: res => {
        localStorage.setItem(this.token, res.jwt);
        subject.next(true);
        subject.complete();
      }, error: err => {
        subject.next(false);
        subject.complete();
      }
    });

    return subject;
  }

  logout() {
    localStorage.clear();
  }
}

class JwtModel {
  jwt!: string;
}
